import * as Yup from 'yup';
import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import ContentCardsContainer, { ContentCard } from 'src/components/organisms/ContentCard';
import { Formik, FormikHelpers } from 'formik';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FormContainerMolecule } from 'src/components/molecules/formik/FormContainerMolecule';
import { FormField } from 'src/components/molecules/formik/FormField';
import CustomButton from 'src/components/atoms/buttons/CustomButton';
import FormHelper from 'src/utils/formHelper';
import useRequest from 'src/hooks/api/useRequest';
import { useMemo } from 'react';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { useGetReceivingOrderByWarehouse } from 'src/hooks/api/requestConfigs/warehouse';
import { useReceivingOrderRowsTable } from 'src/hooks/table/configs/useReceivingOrdersTable';

const scheme = Yup.object().shape({
});

const defaultInitialValues: any = {
};

const useReceivingOrderForm = (editId, defaultValues) => {
    const { rows: receivingAdvice }: any = useGetReceivingOrderByWarehouse(editId, 12);

    const initialValues = useMemo(() => {
        if (receivingAdvice) return FormHelper.mapToInitialValues(receivingAdvice);

        return editId != null
            ? { ...defaultValues, Id: editId }
            : defaultValues;
    }, [receivingAdvice, editId]);

    return initialValues;
};

function EditReceivingOrder() {
    const [editId, PageName, currentSubmitFunction] = FormHelper.getEditPageConfig("Receiving Order");
    const [result, setRequest] = useRequest({ logLevel: ["error", "success"] });
    const initialValues = useReceivingOrderForm(editId, defaultInitialValues);
    const [rowColumns, rowTableSettings] = useReceivingOrderRowsTable(editId);

    return (
        <>
            <Formik
                key={initialValues?.ItemId ?? 'loading-receiving-order'}
                initialValues={initialValues}
                validateOnBlur={true}
                validateOnChange={false}
                validationSchema={scheme}
                onSubmit={(values: any, formikHelpers: FormikHelpers<any>) => {
                    setRequest(currentSubmitFunction(values));
                    formikHelpers.setSubmitting(false);
                }}
                enableReinitialize
            >
                {(props): JSX.Element => (
                    <div>
                        <PageHeader {...{
                            title: PageName,
                            initialValues: initialValues,
                            subTitle: "View and edit Receiving Advice",
                            components: [
                                // { component: <CustomButton icon={<ArrowBackIcon />} title="All Receiving Orders" actionUrl="/warehouse/receiving-orders" /> },
                                // { component: <CustomButton isSubmitting={props.isSubmitting} onClick={props.handleSubmit} title="Save" icon={<SaveIcon />} /> },
                            ],
                            alertData: { dataArray: (result ?? false) ? [result] : null }
                        }} />

                        <ContentCardsContainer>
                            <ContentCard {...{ cardId: "Receiving Advice", md: 6 }}>
                                <FormContainerMolecule formikProps={props}>
                                    <FormField fieldProps={{ name: "Sender", label: "Sender", md: 12 }} formikProps={props} />
                                    <FormField fieldProps={{ name: "DeliveryNoteRef", label: "Delivery Note Ref", md: 5.8 }} formikProps={props} />
                                    <FormField fieldProps={{ name: "Note", label: "Note", md: 5.8 }} formikProps={props} />
                                </FormContainerMolecule>
                            </ContentCard>

                            <ContentCard {...{ cardId: "Information", md: 6 }}>
                                <FormContainerMolecule disabled={true} formikProps={props}>
                                    <FormField fieldProps={{ name: "Id", label: "Receiving Advice Id", md: 5.8 }} formikProps={props} />
                                    <FormField fieldProps={{ name: "WarehouseId", label: "Warehouse Id", md: 5.8 }} formikProps={props} />
                                    <FormField fieldProps={{ name: "ExternalDocumentId", label: "External Document Id", md: 5.8 }} formikProps={props} />
                                    <FormField fieldProps={{ name: "ReceivingAdviceTypeId", label: "Receiving Advice Type Id", md: 5.8 }} formikProps={props} />
                                    <FormField fieldProps={{ name: "ItemId", label: "Item Id", md: 5.8 }} formikProps={props} />
                                </FormContainerMolecule>
                            </ContentCard>

                            <ContentCard {...{ cardId: "Receiving Rows", md: 12, contentPadding: 0 }}>
                                <CustomDataGrid columns={rowColumns} tableSettings={rowTableSettings} />
                            </ContentCard>
                        </ContentCardsContainer>
                    </div>
                )}
            </Formik>

            <Footer />
        </>
    );
}

export default EditReceivingOrder;